declare var ga: any;
declare var fbq: any;

import {getUserUid} from '@/services/helpers';

const appStartedTimestamp = new Date(); // note this will be executed only one time

export default class Logger {
  public static logLoaded() {
    Logger.logEvent('loaded');
  }

  public static logLocationChange(location: object) {
    Logger.logEvent('userChooseLocation', {location});
  }

  public static logRadiusChange(value: number) {
    Logger.logEvent('userChangeRadius', {value});
  }

  public static logKeywordType(keyword: string) {
    Logger.logEvent('userTypeKeyword', {value: keyword});
  }

  public static logAddPopularKeyword(keyword: string) {
    Logger.logEvent('addPopularKeyword', {value: keyword});
  }

  public static logKeywordDelete(keyword: string) {
    Logger.logEvent('userDeleteSelectedKeyword', {value: keyword});
  }

  public static logNoKeywordsError() {
    Logger.logEvent('errorUserNotSelectedKeywords');
  }

  public static logGetQuoteClick() {
    Logger.logEvent('userClickGetQuoteBtn');
  }

  public static logCvDClick() {
    Logger.logEvent('userClickCvDBtn');
  }

  public static logClickNoThankYou() {
    Logger.logEvent('userClickNoThankYou');
  }

  public static logChangeStep(currentStep: number, previousStep: number) {
    Logger.logEvent('userChangeStep', {
      fromStep: previousStep,
      toStep: currentStep,
    });
  }

  private static logEvent(name: string, payload?: object) {
    const uid = getUserUid();
    if (!uid) {
      console.error('No uid provided - logger will not work.'); // tslint:disable-line
      return;
    }


    try {

      try {

        ga('send', {
          eventCategory: 'jobFlow',
          hitType: 'event',
          eventAction: name || ""
        });
      } catch (e) {

      }

    } catch (e) {

    }


    try {

      fbq('trackCustom',  name || "", {
        urlSearch: location.href
      });

    } catch (e) {

    }



    const options = {
      uid,
      name,
      type: 'website',
      url: location.href,
      referrer: document.referrer,
      hostname: location.hostname,
      botName: 'jobLandingPage',
      diff: new Date().getTime() - appStartedTimestamp.getTime(),
      ...payload,
    };

    fetch(`${process.env.VUE_APP_API_ENDPOINT}/log-events`, {
      method: 'POST',
      body: JSON.stringify(options),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}


